import React, { createContext, useContext, useState, useEffect } from 'react';
import translations from './translations';

const LanguageContext = createContext();

const STORAGE_KEY = 'aid_language';
const SUPPORTED = ['fr', 'en', 'pl'];

const detectInitialLanguage = () => {
  // 1. localStorage (choix explicite de l'utilisateur)
  const stored = typeof window !== 'undefined' && localStorage.getItem(STORAGE_KEY);
  if (stored && SUPPORTED.includes(stored)) return stored;

  // 2. Domaine (.fr / .pl)
  if (typeof window !== 'undefined') {
    const host = window.location.hostname;
    if (host.endsWith('.pl')) return 'pl';
    if (host.endsWith('.com') || host.endsWith('.org')) return 'en';
  }

  // 3. Langue du navigateur
  if (typeof navigator !== 'undefined') {
    const nav = (navigator.language || 'fr').toLowerCase().slice(0, 2);
    if (SUPPORTED.includes(nav)) return nav;
  }

  return 'fr';
};

export const LanguageProvider = ({ children }) => {
  const [language, setLanguageState] = useState(detectInitialLanguage);

  const setLanguage = (lang) => {
    if (SUPPORTED.includes(lang)) {
      setLanguageState(lang);
      localStorage.setItem(STORAGE_KEY, lang);
      document.documentElement.lang = lang;
    }
  };

  useEffect(() => {
    document.documentElement.lang = language;
  }, [language]);

  // Fonction de traduction : t('nav.home')
  const t = (path) => {
    const keys = path.split('.');
    let value = translations[language];
    for (const k of keys) {
      value = value?.[k];
      if (value === undefined) break;
    }
    // Fallback en français si la clé n'existe pas dans la langue active
    if (value === undefined) {
      let fallback = translations.fr;
      for (const k of keys) fallback = fallback?.[k];
      return fallback || path;
    }
    return value;
  };

  return (
    <LanguageContext.Provider value={{ language, setLanguage, t, supported: SUPPORTED }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) throw new Error('useLanguage must be used within LanguageProvider');
  return context;
};
